module.exports = __webpack_public_path__ + "media/images/icon__checkmark--rb-dark-gray@3x-950f7ad216b82e6ed77cf8c62c291723.png";